import { TextField, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import "./ResetPasswordInputPage.scss";
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import loaderLottie from '../../../../assets/lottie_animations/bubble-loader.json';
import successLottie from '../../../../assets/lottie_animations/success-lottie.json';
import { PasswordResetFlowController } from '../hooks/usePasswordResetFlow';
import { PasswordResetStep } from '../../../../enums/AuthFlowEnums';


interface ResetPasswordInputPageProps {
    flow: PasswordResetFlowController
}

const ResetPasswordInputPage = ({ flow }: ResetPasswordInputPageProps) => {
  return (
    <div className='reset-password-input-page'> 
    {
        flow.step === PasswordResetStep.Success ? 
        <>
        <Lottie className="success-lottie" animationData={successLottie} loop={true}></Lottie>
        <Typography fontWeight={1000} marginBottom={"15px"}>Successfully changed your password. <br/> Re-logging you now.</Typography>
        </> : 
         <>
         <Typography fontWeight={1000} marginBottom={"15px"}>Please choose a new password for your Geniegig account</Typography>
         <TextField type='password' label='Enter new password' value={flow.newPassword} fullWidth onChange={(e: any) => flow.setNewPassword(e.target.value)}/>
         <TextField type='password' label='Confirm new password' value={flow.confirmPassword} fullWidth onChange={(e: any) => flow.setConfirmPassword(e.target.value)} 
             helperText={ <Typography sx={{color:'red'}} variant='caption'>{flow.error}</Typography>}
         />
         
         {
             flow.isLoading ? 
             <Lottie className="loader-lottie" animationData={loaderLottie} loop={true}></Lottie> : 
             <GGButton className='btn-primary' onClick={flow.changePassword} variant='contained'> 
                 Change Password and Login
             </GGButton>
         }
         </>
    }
        
       
    </div>
  )
}

export default ResetPasswordInputPage